import { useSelector } from 'react-redux';
import { Application, ApplicationVersion } from '@raydiant/api-client-js';
import GridItem from '../../../components/Grid/GridItem';
import MarketplaceCard from '../../../components/MarketplaceCard';
import { userHasPremiumApp } from '../MarketplacePageUtils';
import { capitalize } from '../../../utilities/stringUtils';
import { selectApplications } from '../../../selectors/applications';
import Text from '@raydiant/raydial/components/Text';
import DefaultMarketplaceCard from '../../../components/MarketplaceCard/DefaultMarketplaceCard';

const isStagingOrLocal = () => {
  if (typeof window === 'undefined') return true;

  return [
    window.location.hostname.includes('staging'),
    window.location.hostname.includes('localhost'),
  ].includes(true);
};

export interface ApplicationGroupProps {
  data: Application[] | undefined;
  groupName: 'content' | 'menu' | 'communication';
  onClick: (application: Application) => void;
  onDefaultMarketplaceCardClick: () => void;
}

const ApplicationGroup = ({
  data,
  groupName,
  onClick,
  onDefaultMarketplaceCardClick,
}: ApplicationGroupProps) => {
  const applications = useSelector(selectApplications);

  const renderApplications = () => {
    const groupedApplications = data?.filter(
      (premiumApp) => premiumApp.applicationCategory?.name === groupName,
    );

    const firstApplication = groupedApplications && groupedApplications[0];

    const fakeArtPlayer =
      firstApplication &&
      ({
        ...firstApplication,
        currentAppVersion: {
          ...firstApplication.currentAppVersion,
          name: 'BlueJeans',
        } as ApplicationVersion,
        name: 'BlueJeans',
      } as Application);

    const showDefaultMarketplaceCard =
      groupedApplications && groupedApplications.length === 0;

    return (
      <div className="flex flex-col gap-4 mb-10">
        <Text variant="subheader" as="h2" className="text-black">
          Premium {capitalize(groupName)} Apps
        </Text>
        <div className="flex w-full justify-center gap-4 flex-col md:flex-wrap md:flex-row md:justify-start md:gap-6">
          {isStagingOrLocal() && fakeArtPlayer && (
            <GridItem key="fake_artplayer">
              <MarketplaceCard
                application={{
                  ...fakeArtPlayer,
                  checked: userHasPremiumApp(fakeArtPlayer, applications),
                }}
                onClick={onClick}
              />
            </GridItem>
          )}
          {showDefaultMarketplaceCard && (
            <GridItem key="default_marketplace_card">
              <DefaultMarketplaceCard onClick={onDefaultMarketplaceCardClick} />
            </GridItem>
          )}
          {!showDefaultMarketplaceCard &&
            groupedApplications?.map((app) => {
              return (
                <GridItem key={app.id}>
                  <MarketplaceCard
                    application={{
                      ...app,
                      checked: userHasPremiumApp(app, applications),
                    }}
                    onClick={onClick}
                  />
                </GridItem>
              );
            })}
        </div>
      </div>
    );
  };

  return <>{renderApplications()}</>;
};

export default ApplicationGroup;
